import React from "react";

import { Row, Col, Card, CardBody, Button } from "shards-react";

const Banner = ({ company }) => {
  const phone = company.phone || "5547997941078";
  const goToWhatsapp = () => {
    window.open(
      `https://wa.me/5547997941078?text=Ol%C3%A1,%20gostaria%20de%20ajuda%20para%20comprar%20projetos%20de%20decora%C3%A7%C3%A3o%20da%20${company.name}.%20`,
      "_blank"
    );
  };
  return (
    <Row className="mb-4">
      <Col>
        <Card>
          <CardBody className="text-center">
            <h4>
              Decoramos ambientes comerciais e residenciais, não encontrou o que
              desejava ou precisa de ajuda para comprar seu projeto?
            </h4>
            <Button theme="accent" size="lg" onClick={goToWhatsapp}>
              Fale com nosso vendedor
            </Button>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default Banner;
